export const majorStations = [
  { 
    name: "Narinkka 1, Helsinki", 
    postalCode: "00100",
    lat: 60.1691, 
    lng: 24.9321,
    areaPostalCodeRange: "01000-00999",
    description: 'Central Helsinki',
    centerLat: 60.1699, // Actual center of Helsinki postal area
    centerLng: 24.9384,
    radiusKm: 15, // Helsinki metro area radius
    connections: [
      "20100", // Turku
      "45100", // Kouvola
      "48600", // Kotka
      "33100", // Tampere
      "65100", // Vaasa
      "15100", // Lahti
      "28130", // Pori
      "40100", // Jyväskylä
      "90130", // Oulu
      "70300", // Kuopio
      "06100", // Porvoo
      "57100",  // Savonlinna
      "13100"  // Hämeenlinna
    ]
  },
  { 
    name: "Narinkka 1, Helsinki", 
    postalCode: "00100",
    lat: 60.1691, 
    lng: 24.9321,
    areaPostalCodeRange: "01000-09990",
    description: 'Greater Helsinki area -> approximating to Kamppi',
    centerLat: 60.2000,
    centerLng: 24.9500,
    radiusKm: 25, // Greater Helsinki area
    connections: [
      "20100", // Turku
      "45100", // Kouvola
      "48600", // Kotka
      "33100", // Tampere
      "65100", // Vaasa
      "15100", // Lahti
      "28130", // Pori
      "40100", // Jyväskylä
      "90130", // Oulu
      "70300", // Kuopio
      "06100", // Porvoo
      "57100",  // Savonlinna
      "13100"  // Hämeenlinna
    ]
  },
  { 
    name: "Narinkka 1, Helsinki", 
    postalCode: "00100",
    lat: 60.1691, 
    lng: 24.9321,
    areaPostalCodeRange: "10000-19990",
    description: 'Lounais Suomi -> approximating to Kamppi',
    centerLat: 60.5000,
    centerLng: 23.5000,
    radiusKm: 50, // Southwest Finland region
    connections: [
      "20100", // Turku
      "45100", // Kouvola
      "48600", // Kotka
      "33100", // Tampere
      "65100", // Vaasa
      "15100", // Lahti
      "28130", // Pori
      "40100", // Jyväskylä
      "90130", // Oulu
      "70300", // Kuopio
      "06100", // Porvoo
      "13100"  // Hämeenlinna
    ]
  },
  {
    name: "Hatanpään valtatie 5-7, Tampere",
    postalCode: "33100",
    lat: 61.495,
    lng: 23.7701,
    areaPostalCodeRange: "33100-33999",
    centerLat: 61.4978, // Tampere center
    centerLng: 23.7610,
    radiusKm: 12,
    connections: [
      "00100", // Helsinki
      "20100", // Turku
      "40100", // Jyväskylä
      "70300", // Kuopio
      "28130", // Pori
      "65100"  // Vaasa
      //,"13100"  Hämeenlinna
    ]
  },
  { 
    name: "Aninkaistenkatu, Turku", 
    postalCode: "20100",
    lat: 60.4544, 
    lng: 22.2604,
    areaPostalCodeRange: "20100-20999",
    centerLat: 60.4518, // Turku center
    centerLng: 22.2666,
    radiusKm: 10,
    connections: [
      "00100", // Helsinki
      "33100", // Tampere
      "28130", // Pori
      "65100"  // Vaasa
    ]
  },
  { 
    name: "Ratakatu 6, Oulu", 
    postalCode: "90130",
    lat: 65.0126, 
    lng: 25.4711,
    areaPostalCodeRange: "90100-90999",
    centerLat: 65.0121, // Oulu center
    centerLng: 25.4651,
    radiusKm: 8,
    connections: [
      "00100", // Helsinki
      "40100", // Jyväskylä
      "70300", // Kuopio
      "96100"  // Rovaniemi
    ]
  },
  {
    name: "Ratakatu 6, Oulu (Northern Finland approximation)",
    postalCode: "90130",  
    lat: 65.0126,
    lng: 25.4711,
    areaPostalCodeRange: "80000-89990",
    description: 'Northern regions of Finland',
    centerLat: 65.0121, // Approximated to Oulu center
    centerLng: 25.4651,
    radiusKm: 60, // Large radius covering northern Finland
    connections: [
      "00100", // Helsinki
      "40100", // Jyväskylä
      "70300", // Kuopio
      "96100"  // Rovaniemi
    ]
  },
  {
    name: "Ratakatu 6, Oulu (Oulu region and Lapland approximation)",
    postalCode: "90130",
    lat: 65.0126, 
    lng: 25.4711,
    areaPostalCodeRange: "90000-99990",
    description: 'Northernmost part of Finland',
    centerLat: 65.0121, // Approximated to Oulu center
    centerLng: 25.4651,
    radiusKm: 70, // Very large radius covering Oulu region and Lapland
    connections: [
      "00100", // Helsinki
      "40100", // Jyväskylä
      "70300", // Kuopio
      "96100"  // Rovaniemi
    ]
  },
  {
    name: "Hannikaisenkatu 20, Jyväskylä",
    postalCode: "40100",
    lat: 62.2415,
    lng: 25.7566,
    areaPostalCodeRange: "40100-40999",
    centerLat: 62.2426, // Jyväskylä center
    centerLng: 25.7473,
    radiusKm: 7,
    connections: [
      "00100", // Helsinki
      "33100", // Tampere
      "70300", // Kuopio
      "90130",  // Oulu
      "15100"  // Lahti 
    ]
  },
  {
    name: "Mikkeli",
    postalCode: "50100",
    areaPostalCodeRange: "50100-50999",
    centerLat: 61.6876,
    centerLng: 27.2722,
    radiusKm: 12,
    description: "Eastern central Finland",
    connections: [
      "00100",
       "70300", 
       "15100"
    ], // Helsinki, Kuopio, Lahti
    region: "Central Finland"
  },
  { 
    name: "Puutarhakatu 3, Kuopio", 
    postalCode: "70300",
    lat: 62.8927, 
    lng: 27.6775,
    areaPostalCodeRange: "70100-70999",
    centerLat: 62.8924, // Kuopio center
    centerLng: 27.6782,
    radiusKm: 6,
    connections: [
      "00100", // Helsinki
      "33100", // Tampere
      "40100", // Jyväskylä
      "90130", // Oulu
      "80100"  // Joensuu
    ]
  },
  {
    name: "Mannerheiminkatu 15, Lahti",
    postalCode: "15100",
    lat: 60.9959,
    lng: 25.6596,
    areaPostalCodeRange: "15100-15999",
    centerLat: 60.9959, // Lahti center
    centerLng: 25.6596,
    radiusKm: 5,
    connections: [
      "00100", // Helsinki
      "33100", // Tampere
      "45100"  // Kouvola
    ]
  },
  { 
    name: "Asema-aukio, Pori", 
    postalCode: "28130",
    lat: 61.4851, 
    lng: 21.7974,
    areaPostalCodeRange: "28100-28999",
    centerLat: 61.4851, // Pori center
    centerLng: 21.7974,
    radiusKm: 6,
    connections: [
      "00100", // Helsinki
      "20100", // Turku
      "33100"  // Tampere
    ]
  },
  { 
    name: "Asemankaari 9, Joensuu", 
    postalCode: "80100",
    lat: 62.601, 
    lng: 29.7636,
    areaPostalCodeRange: "80100-80999",
    centerLat: 62.601, // Joensuu center
    centerLng: 29.7636,
    radiusKm: 5,
    connections: [
      "70300"  // Kuopio
    ]
  },
  { 
    name: "Ratakatu 17, Vaasa", 
    postalCode: "65100",
    lat: 63.0951, 
    lng: 21.6165,
    areaPostalCodeRange: "65100-65999",
    centerLat: 63.0951, // Vaasa center
    centerLng: 21.6165,
    radiusKm: 6,
    connections: [
      "00100", // Helsinki
      "20100", // Turku
      "28130", // Pori
    ]
  },
  {
    name: "Lapinkävijäntie 2, Rovaniemi",
    postalCode: "96100",
    lat: 66.5039,
    lng: 25.7294,
    areaPostalCodeRange: "96100-96999",
    centerLat: 66.5039, // Rovaniemi center
    centerLng: 25.7294,
    radiusKm: 8,
    connections: [
      "90130"  // Oulu
    ]
  },
  { 
    name: "Matkakuja 2, Kotka", 
    postalCode: "48600",
    lat: 60.4664, 
    lng: 26.9459,
    areaPostalCodeRange: "48100-48999",
    centerLat: 60.4664, // Kotka center
    centerLng: 26.9459,
    radiusKm: 5,
    connections: [
      "00100"  // Helsinki
    ]
  },
  {
    name: "Kouvolankatu 22, Kouvola",
    postalCode: "45100",
    lat: 60.867,
    lng: 26.7042,
    areaPostalCodeRange: "45100-45999",
    centerLat: 60.867, // Kouvola center
    centerLng: 26.7042,
    radiusKm: 5,
    connections: [
      "15100"  // Lahti
    ]
  }
];


export const minorStations = [
      {
    name: "Hallituskatu 22, Hämeenlinna",
    postalCode: "13100",
    lat: 60.9953,
    lng: 24.459,
    areaPostalCodeRange: "13100-13999",
    centerLat: 60.9953, // Hämeenlinna center
    centerLng: 24.459,
    radiusKm: 4,
    connections: [
      "00100"  // Helsinki
      ,"33100" // Tampere
    ]
  },
  {
    name: "Salo",
    postalCode: "24100",
    areaPostalCodeRange: "24100-24999",
    centerLat: 60.3847,
    centerLng: 23.1300,
    radiusKm: 8,
    description: "Between Turku and Helsinki",
    connections: ["20100", "00100"], // Turku, Helsinki
    region: "Southern Finland"
  },
  {
    name: "Porvoo",
    postalCode: "06100",
    areaPostalCodeRange: "06100-06999",
    centerLat: 60.3953,
    centerLng: 25.6656,
    radiusKm: 12,
    description: "Eastern Helsinki connection",
    connections: ["00100"], // Helsinki
    region: "Southern Finland"
  },
  {
    name: "Kotka",
    postalCode: "48100",
    areaPostalCodeRange: "48100-48999",
    centerLat: 60.4664,
    centerLng: 26.9458,
    radiusKm: 10,
    description: "Southeastern coastal city",
    connections: ["00100", "45100"], // Helsinki, Kouvola
    region: "Southern Finland"
  },
  {
    name: "Kouvola",
    postalCode: "45100",
    areaPostalCodeRange: "45100-45999",
    centerLat: 60.8678,
    centerLng: 26.7042,
    radiusKm: 15,
    description: "Eastern Finland junction",
    connections: ["00100", "15100"], // Helsinki, Lahti
    region: "Southern Finland"
  },
  {
    name: "Lappeenranta",
    postalCode: "53100",
    areaPostalCodeRange: "53100-53999",
    centerLat: 61.0587,
    centerLng: 28.1886,
    radiusKm: 12,
    description: "Russian border region",
    connections: ["00100", "70300"], // Helsinki, Kuopio
    region: "Southern Finland"
  },
  {
    name: "Hämeenlinna",
    postalCode: "13100",
    areaPostalCodeRange: "13100-13999",
    centerLat: 60.9965,
    centerLng: 24.4641,
    radiusKm: 10,
    description: "Between Helsinki and Tampere",
    connections: ["00100", "33100", "15100"], // Helsinki, Tampere, Lahti
    region: "Southern Finland"
  },
  {
    name: "Lohja",
    postalCode: "08100",
    areaPostalCodeRange: "08100-08999",
    centerLat: 60.2487,
    centerLng: 24.0662,
    radiusKm: 8,
    description: "Western Helsinki suburb",
    connections: ["00100",'20100'], // Helsinki Turku
    region: "Southern Finland"
  },
  {
    name: "Inkeroinen",
    postalCode: "45510",
    areaPostalCodeRange: "45100-45999",
    centerLat: 60.8167,
    centerLng: 26.6167,
    radiusKm: 5,
    description: "Near Kouvola",
    connections: ["45100"], // Kouvola
    region: "Southern Finland"
  },

  // Western Finland Region
  {
    name: "Rauma",
    postalCode: "26100",
    areaPostalCodeRange: "26100-26999",
    centerLat: 61.1274,
    centerLng: 21.5112,
    radiusKm: 8,
    description: "Western coast",
    connections: ["20100", "28130"], // Turku, Pori
    region: "Western Finland"
  },
  {
    name: "Seinäjoki",
    postalCode: "60100",
    areaPostalCodeRange: "60100-60999",
    centerLat: 62.7902,
    centerLng: 22.8404,
    radiusKm: 15,
    description: "Western Finland hub",
    connections: ["33100", "65100", "40100"], // Tampere, Vaasa, Jyväskylä
    region: "Western Finland"
  },
  {
    name: "Kokkola",
    postalCode: "67100",
    areaPostalCodeRange: "67100-67999",
    centerLat: 63.8382,
    centerLng: 23.1316,
    radiusKm: 12,
    description: "Western coast",
    connections: ["65100", "90130"], // Vaasa, Oulu
    region: "Western Finland"
  },
  {
    name: "Pietarsaari",
    postalCode: "68600",
    areaPostalCodeRange: "68600-68999",
    centerLat: 63.6748,
    centerLng: 22.7021,
    radiusKm: 7,
    description: "Western coast",
    connections: ["65100"], // Vaasa
    region: "Western Finland"
  },
  {
    name: "Kristiinankaupunki",
    postalCode: "64100",
    areaPostalCodeRange: "64100-64999",
    centerLat: 62.2741,
    centerLng: 21.3758,
    radiusKm: 6,
    description: "Western coast",
    connections: ["65100", "28130"], // Vaasa, Pori
    region: "Western Finland"
  },
  {
    name: "Närpiö",
    postalCode: "64200",
    areaPostalCodeRange: "64100-64999",
    centerLat: 62.4732,
    centerLng: 21.3396,
    radiusKm: 5,
    description: "Western coast",
    connections: ["65100"], // Vaasa
    region: "Western Finland"
  },

  {
    name: "Savonlinna",
    postalCode: "57100",
    areaPostalCodeRange: "57100-57999",
    centerLat: 61.8681,
    centerLng: 28.8793,
    radiusKm: 10,
    description: "Eastern lakes region",
    connections: ["70300", "50100"], // Kuopio, Mikkeli
    region: "Central Finland"
  },
  {
    name: "Varkaus",
    postalCode: "78200",
    areaPostalCodeRange: "78100-78999",
    centerLat: 62.3147,
    centerLng: 27.8739,
    radiusKm: 8,
    description: "Between Kuopio and Mikkeli",
    connections: ["70300", "50100"], // Kuopio, Mikkeli
    region: "Central Finland"
  },
  {
    name: "Iisalmi",
    postalCode: "74100",
    areaPostalCodeRange: "74100-74999",
    centerLat: 63.5589,
    centerLng: 27.1903,
    radiusKm: 10,
    description: "Northern central Finland",
    connections: ["70300", "90130"], // Kuopio, Oulu
    region: "Central Finland"
  },
  {
    name: "Äänekoski",
    postalCode: "44200",
    areaPostalCodeRange: "44100-44999",
    centerLat: 62.5999,
    centerLng: 25.7330,
    radiusKm: 6,
    description: "Near Jyväskylä",
    connections: ["40100"], // Jyväskylä
    region: "Central Finland"
  },
  {
    name: "Saarijärvi",
    postalCode: "43100",
    areaPostalCodeRange: "43100-43999",
    centerLat: 62.7069,
    centerLng: 25.2537,
    radiusKm: 8,
    description: "Central Finland",
    connections: ["40100"], // Jyväskylä
    region: "Central Finland"
  },
  {
    name: "Viitasaari",
    postalCode: "44500",
    areaPostalCodeRange: "44100-44999",
    centerLat: 63.0732,
    centerLng: 25.8549,
    radiusKm: 7,
    description: "Central Finland",
    connections: ["40100"], // Jyväskylä
    region: "Central Finland"
  },
  {
    name: "Pihtipudas",
    postalCode: "44800",
    areaPostalCodeRange: "44100-44999",
    centerLat: 63.3727,
    centerLng: 25.5713,
    radiusKm: 6,
    description: "Central Finland",
    connections: ["40100"], // Jyväskylä
    region: "Central Finland"
  },

  // Northern Finland Region
  {
    name: "Kemi",
    postalCode: "94100",
    areaPostalCodeRange: "94100-94999",
    centerLat: 65.7362,
    centerLng: 24.5662,
    radiusKm: 10,
    description: "Northern coast",
    connections: ["90130", "96200"], // Oulu, Rovaniemi
    region: "Northern Finland"
  },
  {
    name: "Tornio",
    postalCode: "95400",
    areaPostalCodeRange: "95100-95999",
    centerLat: 65.8481,
    centerLng: 24.1462,
    radiusKm: 8,
    description: "Swedish border",
    connections: ["94100", "96200"], // Kemi, Rovaniemi
    region: "Northern Finland"
  },
  {
    name: "Raahe",
    postalCode: "92100",
    areaPostalCodeRange: "92100-92999",
    centerLat: 64.6829,
    centerLng: 24.4777,
    radiusKm: 8,
    description: "Northern coast",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },
  {
    name: "Ylivieska",
    postalCode: "84100",
    areaPostalCodeRange: "84100-84999",
    centerLat: 64.0736,
    centerLng: 24.5436,
    radiusKm: 10,
    description: "Northern Finland",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },
  {
    name: "Kuusamo",
    postalCode: "93600",
    areaPostalCodeRange: "93600-93999",
    centerLat: 65.9648,
    centerLng: 29.1910,
    radiusKm: 15,
    description: "Eastern Lapland border",
    connections: ["90130", "96200"], // Oulu, Rovaniemi
    region: "Northern Finland"
  },
  {
    name: "Pudasjärvi",
    postalCode: "93300",
    areaPostalCodeRange: "93100-93599",
    centerLat: 65.3832,
    centerLng: 26.9139,
    radiusKm: 12,
    description: "Northeastern Finland",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },
  {
    name: "Taivalkoski",
    postalCode: "93400",
    areaPostalCodeRange: "93100-93599",
    centerLat: 65.5735,
    centerLng: 28.2391,
    radiusKm: 8,
    description: "Northeastern Finland",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },

  // Lapland Region
  {
    name: "Sodankylä",
    postalCode: "99600",
    areaPostalCodeRange: "99600-99699",
    centerLat: 67.4170,
    centerLng: 26.5907,
    radiusKm: 15,
    description: "Central Lapland",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Saariselkä",
    postalCode: "99830",
    areaPostalCodeRange: "99800-99899",
    centerLat: 68.4131,
    centerLng: 27.4069,
    radiusKm: 10,
    description: "Northern Lapland ski resort",
    connections: ["96200", "99800"], // Rovaniemi, Ivalo
    region: "Lapland"
  },
  {
    name: "Ivalo",
    postalCode: "99800",
    areaPostalCodeRange: "99800-99899",
    centerLat: 68.6561,
    centerLng: 27.5439,
    radiusKm: 12,
    description: "Far northern Lapland",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Levi",
    postalCode: "99130",
    areaPostalCodeRange: "99100-99199",
    centerLat: 67.8058,
    centerLng: 24.8094,
    radiusKm: 8,
    description: "Major ski resort",
    connections: ["99100", "96200"], // Kittilä Airport, Rovaniemi
    region: "Lapland"
  },
  {
    name: "Muonio",
    postalCode: "99300",
    areaPostalCodeRange: "99300-99399",
    centerLat: 67.9526,
    centerLng: 23.6783,
    radiusKm: 10,
    description: "Northwestern Lapland",
    connections: ["99100"], // Kittilä Airport
    region: "Lapland"
  },
  {
    name: "Ruka",
    postalCode: "93825",
    areaPostalCodeRange: "93800-93899",
    centerLat: 66.1647,
    centerLng: 29.1394,
    radiusKm: 6,
    description: "Eastern Lapland ski resort",
    connections: ["93600"], // Kuusamo
    region: "Lapland"
  },
  {
    name: "Tankavaara",
    postalCode: "99695",
    areaPostalCodeRange: "99600-99699",
    centerLat: 68.3167,
    centerLng: 27.0167,
    radiusKm: 5,
    description: "Gold panning village",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Kakslauttanen",
    postalCode: "99890",
    areaPostalCodeRange: "99800-99899",
    centerLat: 68.3667,
    centerLng: 27.6167,
    radiusKm: 4,
    description: "Glass igloo resort",
    connections: ["99800"], // Ivalo
    region: "Lapland"
  },
  {
    name: "Muonio",
    postalCode: "99300",
    areaPostalCodeRange: "99300-99399",
    centerLat: 67.9526,
    centerLng: 23.6783,
    description: "Northwestern Lapland",
    connections: ["99100"], // Kittilä Airport
    region: "Lapland"
  },
  {
    name: "Ruka",
    postalCode: "93825",
    areaPostalCodeRange: "93800-93899",
    centerLat: 66.1647,
    centerLng: 29.1394,
    description: "Eastern Lapland ski resort",
    connections: ["93600"], // Kuusamo
    region: "Lapland"
  },
  {
    name: "Tankavaara",
    postalCode: "99695",
    areaPostalCodeRange: "99600-99699",
    centerLat: 68.3167,
    centerLng: 27.0167,
    description: "Gold panning village",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Kakslauttanen",
    postalCode: "99890",
    areaPostalCodeRange: "99800-99899",
    centerLat: 68.3667,
    centerLng: 27.6167,
    description: "Glass igloo resort",
    connections: ["99800"], // Ivalo
    region: "Lapland"
  },

  // Additional Central/Southern Stops
  {
    name: "Orivesi",
    postalCode: "35300",
    areaPostalCodeRange: "35300-35999",
    centerLat: 61.6768,
    centerLng: 24.3598,
    radiusKm: 7,
    description: "Between Tampere and Jyväskylä",
    connectedToMajorStops: ["33100", "40100"], // Tampere, Jyväskylä
    region: "Central Finland"
  },
  {
    name: "Sastamala",
    postalCode: "38200",
    areaPostalCodeRange: "38200-38999",
    centerLat: 61.3387,
    centerLng: 22.9171,
    radiusKm: 8,
    description: "Near Tampere",
    connectedToMajorStops: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Valkeakoski",
    postalCode: "37600",
    areaPostalCodeRange: "37600-37999",
    centerLat: 61.2668,
    centerLng: 24.0301,
    radiusKm: 6,
    description: "South of Tampere",
    connectedToMajorStops: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Heinola",
    postalCode: "18100",
    areaPostalCodeRange: "18100-18999",
    centerLat: 61.2059,
    centerLng: 26.0378,
    radiusKm: 8,
    description: "Between Lahti and Mikkeli",
    connectedToMajorStops: ["15100", "50100"], // Lahti, Mikkeli
    region: "Central Finland"
  },
  {
    name: "Kalajoki",
    postalCode: "85100",
    areaPostalCodeRange: "85100-85999",
    centerLat: 64.2567,
    centerLng: 23.9501,
    description: "Northern coast",
    connections: ["67100"], // Kokkola
    region: "Northern Finland"
  },
  {
    name: "Hamina",
    postalCode: "49400",
    areaPostalCodeRange: "49400-49999",
    centerLat: 60.5695,
    centerLng: 27.1982,
    description: "Southeastern border city",
    connections: ["48100"], // Kotka
    region: "Southern Finland"
  },
  {
    name: "Loviisa",
    postalCode: "07900",
    areaPostalCodeRange: "07900-07999",
    centerLat: 60.4565,
    centerLng: 26.2247,
    description: "Southern coast",
    connections: ["06100"], // Porvoo
    region: "Southern Finland"
  },
  {
    name: "Mynämäki",
    postalCode: "23100",
    areaPostalCodeRange: "23100-23999",
    centerLat: 60.6745,
    centerLng: 21.9978,
    description: "Southwest Finland",
    connections: ["20100"], // Turku
    region: "Southern Finland"
  },
  {
    name: "Merikarvia",
    postalCode: "29900",
    areaPostalCodeRange: "29900-29999",
    centerLat: 61.8578,
    centerLng: 21.4928,
    description: "Western coast",
    connections: ["28130"], // Pori
    region: "Western Finland"
  },
  {
    name: "Huittinen",
    postalCode: "32700",
    areaPostalCodeRange: "32700-32999",
    centerLat: 61.1758,
    centerLng: 22.6998,
    description: "Southwest Finland",
    connections: ["28130"], // Pori
    region: "Western Finland"
  },
  {
    name: "Ikaalinen",
    postalCode: "39500",
    areaPostalCodeRange: "39500-39999",
    centerLat: 61.7678,
    centerLng: 23.0578,
    description: "Between Tampere and Pori",
    connections: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Parkano",
    postalCode: "39700",
    areaPostalCodeRange: "39700-39799",
    centerLat: 62.0098,
    centerLng: 23.0278,
    description: "Central western Finland",
    connections: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Hämeenkyrö",
    postalCode: "39100",
    areaPostalCodeRange: "39100-39499",
    centerLat: 61.6378,
    centerLng: 23.1978,
    description: "Near Tampere",
    connections: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Pälkäne",
    postalCode: "36600",
    areaPostalCodeRange: "36600-36999",
    centerLat: 61.3378,
    centerLng: 24.2378,
    description: "East of Tampere",
    connections: ["33100"], // Tampere
    region: "Central Finland"
  },
  {
    name: "Tuulos",
    postalCode: "14300",
    areaPostalCodeRange: "14300-14999",
    centerLat: 61.0378,
    centerLng: 24.7378,
    description: "Between Hämeenlinna and Lahti",
    connections: ["13100"], // Hämeenlinna
    region: "Southern Finland"
  },
  {
    name: "Liminka",
    postalCode: "91900",
    areaPostalCodeRange: "91900-91999",
    centerLat: 64.8078,
    centerLng: 25.4178,
    description: "Near Oulu",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },
  {
    name: "Ii",
    postalCode: "91100",
    areaPostalCodeRange: "91100-91899",
    centerLat: 65.3178,
    centerLng: 25.3578,
    description: "North of Oulu",
    connections: ["90130"], // Oulu
    region: "Northern Finland"
  },
  {
    name: "Tervola",
    postalCode: "95300",
    areaPostalCodeRange: "95300-95399",
    centerLat: 66.0878,
    centerLng: 24.8078,
    description: "Between Kemi and Rovaniemi",
    connections: ["94100", "96200"], // Kemi, Rovaniemi
    region: "Northern Finland"
  },
  {
    name: "Ylitornio",
    postalCode: "95600",
    areaPostalCodeRange: "95600-95999",
    centerLat: 66.3178,
    centerLng: 23.6578,
    description: "Swedish border, north of Tornio",
    connections: ["95400"], // Tornio
    region: "Northern Finland"
  },
  {
    name: "Ranua",
    postalCode: "97700",
    areaPostalCodeRange: "97700-97999",
    centerLat: 65.9078,
    centerLng: 26.5278,
    description: "Arctic Circle, wildlife park",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Pyhä",
    postalCode: "98530",
    areaPostalCodeRange: "98500-98599",
    centerLat: 67.0078,
    centerLng: 27.1878,
    description: "Lapland ski resort",
    connections: ["96200"], // Rovaniemi
    region: "Lapland"
  },
  {
    name: "Simo",
    postalCode: "95200",
    areaPostalCodeRange: "95200-95299",
    centerLat: 65.6678,
    centerLng: 25.0578,
    description: "Between Kemi and Tornio",
    connections: ["94100"], // Kemi
    region: "Northern Finland"
  }
];
